import React from 'react';
import { Text, Button, VStack, Box, Flex } from '@chakra-ui/react';
import { Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';

type DuplicateFileModalProps = {
  isOpen: boolean;
  fileName?: string | null;
  fieldName?: string | null;
  onContinue: () => void;
  onCancel: () => void;
};

const DuplicateFileModal: React.FC<DuplicateFileModalProps> = ({
  isOpen,
  onCancel,
  fileName,
  fieldName,
  onContinue
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      width="25rem"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} padding={0} borderRadius={50}>
        {/* Top Red Header */}
        <Box
          backgroundColor={'attentionPrimaryContentAccent'}
          borderTopRadius={6}
          py={8}
        >
          <VStack spacing={3}>
            <FontAwesomeIcon fontSize={40} icon={faWarning} />
          </VStack>
        </Box>

        {/* Content */}
        <VStack spacing={4} px={8} py={6} textAlign="center">
          <Text textStyle={'headingSection'} color="gray.800">
            Duplicate File Detected!
          </Text>

          <Text textStyle={'textContext'}>
            The file{' '}
            <Text as={'span'} wordBreak={'break-all'} whiteSpace={'normal'} textStyle={'headingItem'}>
              {fileName}
            </Text>{' '}
            has already been uploaded in the{' '}
            <Text as={'span'} textStyle={'headingItem'}>
              {fieldName}
            </Text>{' '}
            field. Please rename the file, choose a different file, or continue
            using the existing file.
          </Text>
          <Flex
            mt={3}
            alignItems={'center'}
            justifyContent={'space-between'}
            w="full"
          >
            <Button onClick={onCancel}>Cancel Upload</Button>
            <Button variant="primary" px={8} onClick={onContinue}>
              Continue Upload
            </Button>
          </Flex>
        </VStack>
      </Flex>
    </Modal>
  );
};

export default DuplicateFileModal;
